import React from 'react'
import PropTypes from 'prop-types'

import './index.css'

const Checkbox = ({ value, checked, onClick }) => {
  return (
    <>
      <div
        data-testid={`facet-checkbox-${value}`}
        aria-hidden="true"
        className={`checkbox__input ${checked ? 'checkbox--checked' : 'checkbox--unchecked'}`}
        checked={checked}
        onClick={onClick}
      >
        {checked && <i className="zmdi zmdi-check" />}
      </div>
      <label className="checkbox__label">{value}</label>
    </>
  )
}

export default Checkbox

Checkbox.defaultProps = {
  onClick: () => {},
}

Checkbox.propTypes = {
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
}
